import type { RegionComponent, RegionDetail, RegionNode } from '../../../../api/regions';

import { RegionActivityCard } from './RegionActivityCard';
import { RegionDangerZone } from './RegionDangerZone';
import { RegionProfilePanel } from './RegionProfilePanel';

interface Props {
  detail: RegionDetail;
  components: RegionComponent[];
  regions: RegionNode[];
  color: string;
  onGone: () => void;
}

/** Right column of the region detail page: profile, activity, danger zone. */
export function RegionDetailSidebar({ detail, components, regions, color, onGone }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, minHeight: 0 }}>
      <RegionProfilePanel detail={detail} components={components} color={color} />
      <RegionActivityCard regionId={detail.id} />
      <RegionDangerZone detail={detail} regions={regions} onGone={onGone} />
    </div>
  );
}
